import Base from 'app/views/base';

import { showError } from 'utils/messages';
import { formatIsoDateTime } from 'utils/dates';

import WebhookDeleteModal from 'app/views/modals/webhook_delete_modal';

import tmpl from './list_item';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click a.delete': 'showDeleteModal',
    'click a.enable': 'enable',
  },

  initialize() {
    this.deleteModal = new WebhookDeleteModal({
      model: this.model,
      collection: this.collection,
    });
  },

  context() {
    return {
      id: this.model.id,
      url: this.model.get('url'),
      disabled_at: formatIsoDateTime(this.model.get('disabled_at')),
    };
  },

  showDeleteModal(event) {
    event.preventDefault();
    this.deleteModal.show();
  },

  enable(event) {
    const self = this;
    event.preventDefault();
    this.model.update({}, {
      success() {
        self.render();
      },
      error() {
        showError('The webhook could not be enabled. Please try again later');
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/webhooks_and_events/webhooks/list_item_view.js